import { render, staticRenderFns } from "./PageViewOld.vue?vue&type=template&id=05a24aca&scoped=true&lang=pug&"
import script from "./PageViewOld.vue?vue&type=script&lang=js&"
export * from "./PageViewOld.vue?vue&type=script&lang=js&"
import style0 from "./PageViewOld.vue?vue&type=style&index=0&id=05a24aca&prod&lang=scss&"
import style1 from "./PageViewOld.vue?vue&type=style&index=1&id=05a24aca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a24aca",
  null
  
)

export default component.exports